import { render, staticRenderFns } from "./wikiPageEdit.vue?vue&type=template&id=fb471e8c&"
import script from "./wikiPageEdit.vue?vue&type=script&lang=ts&"
export * from "./wikiPageEdit.vue?vue&type=script&lang=ts&"
import style0 from "./wikiPageEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports